// Author lidongxu
// Date 2023-08-17 14:04:13

import * as model from "@/model/em/admin/EmDictTypeModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmDictType(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ADMIN_URL,
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'editEntity'
    })
    .buildStore()
